const ArrowLeftIcon = ({
  width = 48,
  height = 48,
  fill = "black",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect opacity="0.03" width="48" height="48" fill={fill} />
    <path
      d="M15.2002 23.726L29.1888 15.6497L29.1888 31.8023L15.2002 23.726Z"
      fill={fill}
    />
  </svg>
);

export default ArrowLeftIcon;
